import { cn } from "@sorcery/ui";
import { LayoutEnum } from "~/state/configJotai";
import type { DeckPreviewType } from "~/types/deck";
import { DeckPreview } from "./DeckPreview";
import { DeckPreviewOfficial } from "./DeckPreviewOfficial";
import { MyDeckPreview } from "./MyDeckPreview";

type Props = {
  decks: DeckPreviewType[];
  align?: "center" | "left";
  variant?: "default" | "official" | "my";
  layout?: LayoutEnum;
};

export const DeckPreviewList = ({
  decks,
  align = "center",
  variant = "default",
  layout = LayoutEnum.GRID,
}: Props) => {
  return (
    <div
      className={`flex flex-row flex-wrap gap-1 ${
        align === "center" ? "justify-center" : "justify-start"
      }`}
    >
      {decks.map((deck) => {
        return (
          <div
            className={cn(
              "w-full duration-500 animate-in fade-in",
              variant === "default" &&
                "sm:w-[calc(50%-4px)] lg:w-[calc(33%-4px)] xl:w-[calc(25%-4px)]",
              variant === "my" &&
                layout === LayoutEnum.GRID &&
                "sm:w-[calc(50%-4px)] lg:w-[calc(33%-4px)] xl:w-[calc(25%-4px)]",
              variant === "official" && "sm:w-[calc(50%-4px)] lg:w-[calc(25%-4px)]",
            )}
            key={deck.id + layout}
          >
            {variant === "my" ? (
              <MyDeckPreview deck={deck} layout={layout} />
            ) : variant === "official" ? (
              <DeckPreviewOfficial deck={deck} />
            ) : (
              <DeckPreview deck={deck} />
            )}
          </div>
        );
      })}
    </div>
  );
};
